import React from "react";
import Signin from "../Components/SignIN_SignUP/Sign_IN";
function SignIN() {
  return <Signin />;
}

export default SignIN;
